import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import Logo from "@/components/Logo";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Bem-vinda, ${u.name.split(" ")[0]}! 💗`);
      nav(u.role === "admin" ? "/admin" : "/minha-conta");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erro ao entrar");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md bg-white rounded-2xl border border-[#F9E1E8] p-8 shadow-sm">
        <div className="text-center mb-6"><Logo /></div>
        <h1 className="font-serif text-2xl text-[#4A3B40] text-center mb-6">Entrar</h1>
        <form onSubmit={submit} className="space-y-3">
          <input type="email" required placeholder="E-mail" value={email} onChange={(e)=>setEmail(e.target.value)} className="w-full border border-[#F9E1E8] bg-[#FFF9FA] rounded-xl px-4 py-3 outline-none focus:border-[#C9708B]" data-testid="login-email" />
          <input type="password" required placeholder="Senha" value={password} onChange={(e)=>setPassword(e.target.value)} className="w-full border border-[#F9E1E8] bg-[#FFF9FA] rounded-xl px-4 py-3 outline-none focus:border-[#C9708B]" data-testid="login-password" />
          <button disabled={loading} className="w-full btn-lara" data-testid="login-submit">{loading?"Entrando...":"Entrar"}</button>
        </form>
        <p className="text-sm text-center text-[#8C7A80] mt-4">
          Não tem conta? <Link to="/cadastro" className="text-[#C9708B] font-semibold hover:underline">Cadastre-se</Link>
        </p>
      </div>
    </div>
  );
}
